import { useCallback, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { CREATE_CRASH_COURSE } from 'queries/crashCourse'
import { createCrashCourse, createCrashCourseVariables } from '__generatedTypes__/createCrashCourse'
import { CreateCrashCourseInput } from '__generatedTypes__/globalTypes'
import { toast } from 'utils/toast'
import { Form } from '../Form'

export const Create = () => {
  const { navigate } = useLink()
  const [searchParams] = useSearchParams()
  const subjectId = searchParams.get('subjectId')
  const defaultOrder = +(searchParams.get('defaultOrder') ?? 0)
  const [create] = useMutation<createCrashCourse, createCrashCourseVariables>(CREATE_CRASH_COURSE)

  const handleSubmit = useCallback(
    async (crashCourse: CreateCrashCourseInput) => {
      try {
        const { data } = await create({
          variables: {
            params: {
              ...crashCourse,
              order: defaultOrder,
            },
          },
        })

        if (data?.createCrashCourse.id) {
          navigate(cmsRoutes.CRASH_COURSE_LIST, undefined, {
            searchParams: new URLSearchParams({ subjectId: String(crashCourse.subject?.id) }),
          })
        }
        toast.success('Crash course created successfully')
      } catch (error) {
        toast.error('Failed to create crash course')
      }
    },
    [create, navigate]
  )

  useEffect(() => {
    if (!subjectId) {
      navigate(cmsRoutes.CRASH_COURSE_LIST)
      toast.error('Subject not found, redirecting to crash course list')
    }
  }, [subjectId])

  if (!subjectId) {
    return null
  }

  return <Form crashCourseOrSubjectId={subjectId} onSubmit={handleSubmit} />
}
